__turbopack_context__.v({
  "cardSubtitle": "ethAea_cardSubtitle",
  "cardTitle": "ethAea_cardTitle",
  "cardsTrack": "ethAea_cardsTrack",
  "cardsViewport": "ethAea_cardsViewport",
  "desktopFrameImage": "ethAea_desktopFrameImage" + " " + "ethAea_frameImage",
  "frameImage": "ethAea_frameImage",
  "framePositioner": "ethAea_framePositioner",
  "frameWrapper": "ethAea_frameWrapper",
  "insightCard": "ethAea_insightCard",
  "mainTitle": "ethAea_mainTitle" + " " + __turbopack_context__.i(527070)["heading"],
  "mobileFrameImage": "ethAea_mobileFrameImage" + " " + "ethAea_frameImage",
  "phoneContainer": "ethAea_phoneContainer",
  "section": "ethAea_section",
  "sequenceCanvas": "ethAea_sequenceCanvas",
  "sequenceWrapper": "ethAea_sequenceWrapper",
  "stickyContainer": "ethAea_stickyContainer",
  "stickyWrapper": "ethAea_stickyWrapper",
});
